
import React from "react";
import { Schemes, Utils } from "../../../../../utils";
import { i18nManager } from "../../../../../i18n";
import { Elements } from "../../../../shared/Elements";
import { Siren } from "../../../../shared/ConfirmDialog";
import * as ReactRouterDom from "react-router-dom";
import LoadingGif from "../../../../assets/images/loading_circle.gif";
import { BaseService, HostService, IHost, IHostWebsite, IMember, IProfileWebsite, ITeam, MemberService, SanitizedResponse } from "../../../../../services";
import { Button, ButtonManageRef, Checkbox, ComposedPassword, DateTimeInput, DateTimePicker, DOMHelper, Dropdown, Form, FormControl, NoseurObject, ObjectHelper, TabPane, TabPanel, TextAreaInput, TextInput } from "@rivtn/noseur";
import ImportExport from "../../../../page_design/ImportExport";
import MediaInput, { MediaInputManageRef } from "../../../../shared/MediaInput";

export interface EmailPhoneProps {
    host: IHost;
    profile: IMember;
    hostWebsite: IHostWebsite;
}

function EmailPhone(props: EmailPhoneProps) {

    const { host } = props;
    const hostService = HostService.getInstance();
    const labels = i18nManager.Labels.host.settings.about.email_phone;
    const [hostWebsite, setHostWebsite] = React.useState<IHostWebsite>(props.hostWebsite);

    return (<Form scheme={Schemes.OMNEHOST} className="profile-settings team-settings" style={{ padding: 0, boxShadow: "none", maxWidth: 600 }}>
        <p style={{ margin: "20px 0px" }}>{labels.email_phone_1}</p>
        <FormControl isFieldset fill label={labels.email}>
            <TextInput defaultValue={hostWebsite.emails_and_phones?.[0]?.email} onInputComplete={(v) => {
                updatePhoneEmail(0, "email", v);
            }} />
        </FormControl>
        <FormControl isFieldset fill label={labels.phone} style={{ marginTop: 20 }}>
            <TextInput defaultValue={hostWebsite.emails_and_phones?.[0]?.phone} onInputComplete={(v) => {
                updatePhoneEmail(0, "phone", v);
            }} />
        </FormControl>
        <p style={{ margin: "20px 0px", marginTop: 50 }}>{labels.email_phone_2}</p>
        <FormControl isFieldset fill label={labels.email}>
            <TextInput defaultValue={hostWebsite.emails_and_phones?.[1]?.email} onInputComplete={(v) => {
                updatePhoneEmail(1, "email", v);
            }} />
        </FormControl>
        <FormControl isFieldset fill label={labels.phone} style={{ marginTop: 20 }}>
            <TextInput defaultValue={hostWebsite.emails_and_phones?.[1]?.phone} onInputComplete={(v) => {
                updatePhoneEmail(1, "phone", v);
            }} />
        </FormControl>
        <Button scheme={Schemes.OMNEHOST} loadingProps={Elements.BUTTON_LOADING_PROPS} text={i18nManager.Labels.common.save_changes}
            style={{ marginTop: 50, padding: "10px 25px", }} onClick={(e) => updateHostSocialAccounts(e.manageRef)} />
    </Form>);

    function updatePhoneEmail(index: number, field: string, value: string) {
        if (!hostWebsite.emails_and_phones?.length || hostWebsite.emails_and_phones?.length < (index + 1)) {
            for (let i = 0; i < (index + 1); i++) {
                hostWebsite.emails_and_phones.push({} as any);
            }
        }
        (hostWebsite.emails_and_phones[index] as any)[field] = value;
        setHostWebsite({ ...hostWebsite });
    }

    function updateHostSocialAccounts(manageRef?: ButtonManageRef) {
        manageRef?.setLoadingState(true);
        hostService.updateHostWebsite(host.external_id, props.hostWebsite).then(({ sanitized }: SanitizedResponse<IHostWebsite>) => {
            Siren.alert(labels.update_successful);
        }).catch(BaseService.reportError).finally(() => manageRef?.setLoadingState(false));
    }

}

export default EmailPhone;
